// 公共请求
import { apiConfig } from '../utils/config'
import { request } from '../utils/request'

//  日历
export function calendar (year, month) {
  return new Promise(function (resolve, reject) {
    request({
      url: apiConfig.calendar,
      method: 'GET',
      data: {
        year: year,
        month: month
      },
      success: (response) => {
        resolve(response)
      },
      fail: (error) => {
        reject(error)
      }
    })
  }).then(function (res) {
    return { ok: true, list: res }
  })
}

//  获取验证码
export function getCaptcha () {
  return new Promise(function (resolve, reject) {
    request({
      url: apiConfig.captcha,
      method: 'GET',
      success: (response) => {
        resolve(response)
      },
      fail: (error) => {
        reject(error)
      }
    })
  }).then(function (res) {
    return { ok: true, ...res }
  })
}

// 发送短信
export function getSendsms (phone) {
  return new Promise(function (resolve, reject) {
    request({
      url: apiConfig.sendsms,
      method: 'POST',
      data: {
        phone: phone
      },
      success: (response) => {
        resolve(response)
      },
      fail: (error) => {
        reject(error)
      }
    })
  }).then(function (res) {
    return { ok: true, ...res }
  })
}

// 获取所有创意tag
export function getIdeataglist (type) {
  return new Promise(function (resolve, reject) {
    request({
      url: apiConfig.ideataglist,
      method: 'GET',
      data: {
        type: type
      },
      success: (response) => {
        resolve(response)
      },
      fail: (error) => {
        reject(error)
      }
    })
  }).then(function (res) {
    return { ok: true, ...res }
  })
}

// 搜索案例
export function getSearch (args) {
  return new Promise(function (resolve, reject) {
    request({
      url: apiConfig.search,
      method: 'POST',
      data: args,
      success: (response) => {
        resolve(response)
      },
      fail: (error) => {
        reject(error)
      }
    })
  }).then(function (res) {
    return { ok: true, ...res }
  })
}

// 获取所有标签
export function getTaglist () {
  return new Promise(function (resolve, reject) {
    request({
      url: apiConfig.taglist,
      method: 'GET',
      success: (response) => {
        resolve(response)
      },
      fail: (error) => {
        reject(error)
      }
    })
  }).then(function (res) {
    return { ok: true, ...res }
  })
}

// 获取当个标签 1行业2用途3风格4事件5亮点 8：感兴趣的产品 9：接受的预算
export function getSinleTaglist (type) {
  return new Promise(function (resolve, reject) {
    request({
      url: apiConfig.taglist,
      method: 'GET',
      data: {
        type: type
      },
      success: (response) => {
        resolve(response)
      },
      fail: (error) => {
        reject(error)
      }
    })
  }).then(function (res) {
    return { ok: true, ...res }
  })
}
